import { render, staticRenderFns } from "./CollapseDivThree.vue?vue&type=template&id=512ef4e3&"
import script from "./CollapseDivThree.vue?vue&type=script&lang=js&"
export * from "./CollapseDivThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports